import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { formatCallTimestamp } from '../../utils/model/llamadas'
import css from './ModalTranscripcionLlamada.module.css'

const ModalTranscripcionLlamada = ({ open, onClose, llamada }) => {
  const groupMessages = transcripcion => {
    if (!transcripcion || transcripcion.length === 0) return []
    const groups = []
    let currentGroup = {
      cliente: transcripcion[0].cliente,
      conversaciones: [transcripcion[0].conversacion],
      inicio: transcripcion[0].inicio,
      fin: transcripcion[0].fin
    }
    for (let i = 1; i < transcripcion.length; i++) {
      const linea = transcripcion[i]
      if (linea.cliente === currentGroup.cliente) {
        currentGroup.conversaciones.push(linea.conversacion)
        currentGroup.fin = linea.fin
      } else {
        groups.push(currentGroup)
        currentGroup = {
          cliente: linea.cliente,
          conversaciones: [linea.conversacion],
          inicio: linea.inicio,
          fin: linea.fin
        }
      }
    }
    groups.push(currentGroup)

    return groups
  }

  const groupedMessages = groupMessages(llamada?.transcripcion)
  const agentName = llamada?.usuario?.nombre || 'Agente'

  return (
    <Dialog onClose={onClose} open={open} maxWidth='md'>
      <DialogTitle>Transcripción de llamada</DialogTitle>
      <DialogContent className={css.main}>
        {groupedMessages.length > 0 ? (
          <div className={css.transcripcion}>
            {groupedMessages.map((group, index) => (
              <div
                key={index}
                className={group.cliente ? css.cliente : css.agente}
              >
                <div className={css.header}>
                  <span className={css.etiqueta}>
                    {group.cliente ? 'Cliente' : agentName}
                  </span>
                  <span className={css.timestamp}>
                    {formatCallTimestamp(group.inicio)} -{' '}
                    {formatCallTimestamp(group.fin)}
                  </span>
                </div>
                <div className={css.conversacion}>
                  {group.conversaciones.map((conversacion, idx) => (
                    <span key={idx}>{conversacion}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={css.noTranscripcion}>
            No hay transcripciones disponibles para esta llamada
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalTranscripcionLlamada
